import { Col } from '../../col';
import { useFormatMembersCount } from '../../header-content';
import { GroupLineIcon } from '../../icons';
import { Row } from '../../row';
import { Text } from '../../typography';

export type ParticipantsProperties = {
  count: number;
  label: (formattedParticipantsCount: string) => string;
};

type P = {
  participants: ParticipantsProperties;
};

export const DataCardParticipants = ({ participants: { count, label } }: P) => {
  const formattedParticipantsCount = useFormatMembersCount({ count });

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        {/* TODO: icon inherits color from parent `a` and appears blue, we need to override its color */}
        <GroupLineIcon size="extra-small" type="dark-default" />
      </Col>
      <Col>
        <Text size="small">{label(formattedParticipantsCount)}</Text>
      </Col>
    </Row>
  );
};
